import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./contexts/CartContext";
import HomePage from "./pages/HomePage";
import ProductDetail from "./pages/ProductDetail";
import CollectionsPage from "./pages/CollectionsPage";
import CartPage from "./pages/CartPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import { Toaster } from "./components/ui/sonner";
import CartDrawer from "./components/CartDrawer";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/collections/:slug" element={<CollectionsPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FAQPage />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
